import React from 'react';
import { completionChecklist, dealInstructions } from '../../data/harrow';

// LAW-001 tab 2. Nothing is pre-ticked: the checklist state is the candidate's
// judgement, not the instrument's.
export function InstructionsPanel() {
  return <div className="h-full overflow-y-auto bg-slate-200/60 p-6" data-id="element-308" data-mp="34estdc5irh7z">
      <div className="mx-auto max-w-3xl space-y-6" data-id="element-309" data-mp="39b9jgbwa45np">
        <article className="rounded-sm bg-white shadow-lg shadow-slate-400/20 ring-1 ring-slate-300" data-id="element-310" data-mp="39dw0d2527xil">
          <header className="border-b border-slate-200 px-8 py-6" data-id="element-311" data-mp="ylqv8yubq0s">
            <span className="inline-flex items-center rounded-full bg-slate-900 px-2.5 py-0.5 text-[11px] font-semibold uppercase tracking-wide text-white" data-id="element-312" data-mp="5uszj9imffmf">
              Instruction
            </span>
            <h3 className="mt-3 text-lg font-semibold text-slate-900" data-id="element-313" data-mp="3s9ccd1ry6mqs">
              {dealInstructions.matter} — deal instructions
            </h3>
            <p className="mt-1 text-xs text-slate-500" data-id="element-314" data-mp="olk5e13egnw2">
              Issued to the corporate team · reporting to the supervising associate
            </p>
          </header>

          <div className="px-8 py-6" data-id="element-315" data-mp="f6yusaxaynto">
            <dl className="grid gap-x-8 gap-y-3 sm:grid-cols-2" data-id="element-316" data-mp="ab01qa114hmx">
              {[['Buyer', dealInstructions.buyer], ['Target', dealInstructions.target], ['Initial target completion date', dealInstructions.initialCompletion], ['Purchase price', dealInstructions.price]].map(([label, value]) => <div key={label} data-id="element-317" data-mp="t0yjjhumpp3r">
                  <dt className="text-[11px] font-semibold uppercase tracking-wider text-slate-500" data-id="element-318" data-mp="szolgsns0gx4">
                    {label}
                  </dt>
                  <dd className="mt-0.5 text-sm text-slate-900" data-id="element-319" data-mp="12yw7s5chnlwd">{value}</dd>
                </div>)}
            </dl>

            <h4 className="mt-7 text-[11px] font-semibold uppercase tracking-wider text-slate-500" data-id="element-320" data-mp="39ok8w2btw5s6">
              Key agreed points
            </h4>
            <ul className="mt-3 space-y-2" data-id="element-321" data-mp="34sbz74geh4se">
              {dealInstructions.points.map(p => <li key={p} className="flex gap-3 text-[13.5px] leading-relaxed text-slate-800" data-id="element-322" data-mp="3ugheq1yjgl66">
                  <span aria-hidden="true" className="mt-2 h-1 w-1 shrink-0 rounded-full bg-slate-400" data-id="element-323" data-mp="2cokq4i9dog0" />
                  {p}
                </li>)}
            </ul>
          </div>

          <footer className="border-t border-slate-200 px-8 py-3 font-mono-num text-[11px] text-slate-400" data-id="element-324" data-mp="ca32q8jtylaf">
            HAR-INS-00 · rendered from source · page 1 of 1
          </footer>
        </article>

        <article className="rounded-sm bg-white shadow-lg shadow-slate-400/20 ring-1 ring-slate-300" data-id="element-325" data-mp="l7dd7rotq6ea">
          <header className="border-b border-slate-200 px-8 py-6" data-id="element-326" data-mp="q29frlrosc5n">
            <span className="inline-flex items-center rounded-full bg-slate-900 px-2.5 py-0.5 text-[11px] font-semibold uppercase tracking-wide text-white" data-id="element-327" data-mp="uxyanbsrh4vm">
              Checklist
            </span>
            <h3 className="mt-3 text-lg font-semibold text-slate-900" data-id="element-328" data-mp="14y8o8xipkebb">Completion checklist</h3>
            <p className="mt-1 text-xs text-slate-500" data-id="element-329" data-mp="2pg9f2vvorl45">
              Status column to be completed by the reviewing fee earner
            </p>
          </header>

          <table className="w-full border-collapse text-sm" data-id="element-330" data-mp="2fh1ze21hbedv">
            <thead data-id="element-331" data-mp="2fjegkczexkpv">
              <tr className="text-left text-[11px] uppercase tracking-wider text-slate-500" data-id="element-332" data-mp="2ai8n2cxxhtfa">
                <th className="border-b border-slate-200 px-8 py-2.5 font-semibold" data-id="element-333" data-mp="2akledgpktg50">Item</th>
                <th className="w-40 border-b border-slate-200 px-8 py-2.5 font-semibold" data-id="element-334" data-mp="387tu0v2wbuz3">Status</th>
              </tr>
            </thead>
            <tbody data-id="element-335" data-mp="2yfo5xwfrlxp6">
              {completionChecklist.map((item, i) => <tr key={item} className="border-b border-slate-100" data-id="element-336" data-mp="2th31fkthcrux" data-mpi={i}>
                  <td className="px-8 py-2.5 text-slate-800" data-id="element-337" data-mp="2tgtd01o32src">
                    <span className="mr-2 font-mono-num text-xs text-slate-400" data-id="element-338" data-mp="3qxikaavsyn84">{i + 1}.</span>
                    {item}
                  </td>
                  <td className="px-8 py-2.5 font-mono-num text-xs text-slate-400" data-id="element-339" data-mp="3m3nvit1cbi26">—</td>
                </tr>)}
            </tbody>
          </table>

          <footer className="border-t border-slate-200 px-8 py-3 font-mono-num text-[11px] text-slate-400" data-id="element-340" data-mp="3bnllk13jm4zj">
            HAR-CL-10 · rendered from source · page 1 of 1
          </footer>
        </article>
      </div>
    </div>;
}